module.exports = __webpack_public_path__ + "static/media/post-contact-failure.28c8496b.png";